import type { TsukumogamiRarity } from './collection';

/**
 * P8-3「シェルの声」: 結末・rarity の世界内一字表記の SSoT。
 *
 * - ending バッジ（EndingView）・完了書（CompletionCertificate）・図鑑の結末チップ
 *   （TsukumogamiCollection）が全て**この同一対応表**を消費する（二重定義の構造遮断）。
 * - 一字表記は spot_gate 印章「合」と同じ語彙系（visual_grammar guide §4.6）。
 * - 色は P8-2（トークン単一化）の管轄。このファイルは文言のみを持つ。
 */
export const ENDING_TYPE_GLYPH: Record<string, string> = {
  true: '真',
  good: '吉',
  normal: '常',
  bad: '凶',
  secret: '秘',
  comedy: '戯'
};

/**
 * endingType（内部値）→ 世界内の一字表記。
 * 未知・未指定は null を返す（内部 enum の生値を画面に漏らさないため、
 * 呼び出し側は非表示にするか「？」等の世界内表記へ倒す）。
 */
export function endingGlyph(type: string | null | undefined): string | null {
  if (!type) return null;
  return ENDING_TYPE_GLYPH[type] ?? null;
}

/**
 * rarity → 世界内の一字表記（P9-1 で図鑑側「常/珍/稀/伝」が正と確定。
 * 完了書（DetailedReport）の COMMON/RARE 英名表記もこの表へ統一する）。
 */
export const RARITY_GLYPH: Record<TsukumogamiRarity, string> = {
  common: '常',
  uncommon: '珍',
  rare: '稀',
  legendary: '伝'
};

/** rarity（文字列）→ 一字表記。未知の値は null（生値を画面に出さない）。 */
export function rarityGlyph(rarity: string | null | undefined): string | null {
  if (!rarity) return null;
  return (RARITY_GLYPH as Record<string, string>)[rarity] ?? null;
}
